import Flatpickr from "flatpickr";

export default {
    install: (app) => {
        window.Flatpickr = Flatpickr;
        import("flatpickr/dist/flatpickr.css");
    },
};
